import { Alert, Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { SERVICE_STATUS_EVENT } from '../../utils/service-status';

const ServiceStatusBanner = () => {
  const [state, setState] = useState({
    available: true,
    message: ''
  });

  useEffect(() => {
    const handleStatusChange = (event) => {
      const detail = event.detail || {};
      setState({
        available: detail.available !== false,
        message: detail.message || ''
      });
    };

    const handleOffline = () => {
      setState({
        available: false,
        message: 'You are offline. Please check your internet connection.'
      });
    };

    const handleOnline = () => {
      setState((prev) => ({ ...prev, available: true, message: '' }));
    };

    window.addEventListener(SERVICE_STATUS_EVENT, handleStatusChange);
    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);

    if (!navigator.onLine) {
      handleOffline();
    }

    return () => {
      window.removeEventListener(SERVICE_STATUS_EVENT, handleStatusChange);
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
    };
  }, []);

  if (state.available) {
    return null;
  }

  return (
    <Box sx={{ position: 'sticky', top: 0, zIndex: 1300, px: { xs: 1, sm: 2 }, pt: 1 }}>
      <Alert
        severity="warning"
        sx={{
          fontFamily: '"Courier New", monospace',
          border: '1px solid rgba(242, 211, 153, 0.45)',
          backgroundColor: 'rgba(30, 18, 10, 0.92)',
          color: '#F2E5CC'
        }}
      >
        {state.message || 'Service is temporarily unavailable. Some content may not load right now.'}
      </Alert>
    </Box>
  );
};

export default ServiceStatusBanner;
